import {Stack} from "@mui/material";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import {ReservationActions, useReservationsState} from "../../../store/reservations.reducer";
import React from "react";
import {useLocalize} from "crqlar-react-common/dist/utils/text.util";
import {useCurrentAppId} from "crqlar-react-common/dist/utils/hooks/app/useOrganizationApps";
import {useDispatch} from "react-redux";

const PackageWizardComponent = () => {
    const {t} = useLocalize()
    const appId = useCurrentAppId()
    const dispatch = useDispatch()

    const {
        tmpReservationGroupWizardReservationService,
    } = useReservationsState(appId)

    return(
        <Stack
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                zIndex: 1000,
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            <Stack
                sx={{
                    backgroundColor: '#fff',
                    border: '2px solid red',
                    borderRadius: '8px',
                    marginTop: 3,
                    width: '100%',
                    maxWidth: 500,
                    alignItems: 'center',
                    justifyContent: 'center',
                    p: 2,
                    gap: 1
                }}
            >
                <Typography>
                    {t('Please select start and end time for', {service: tmpReservationGroupWizardReservationService?.name})}
                </Typography>
                <Button
                    onClick={() => {
                        dispatch({
                            type: ReservationActions.SET_RESERVATIONS,
                            appId: appId,
                            payload: {
                                tmpReservationGroupDialogOpen: true,
                                tmpReservationGroupWizardActive: false
                            }
                        })
                    }}
                >
                    {t('Cancel wizard')}
                </Button>
            </Stack>
        </Stack>
    )
}

export default PackageWizardComponent
